import React from "react";
import JsonView from "react-json-view";
//import PropTypes from 'prop-types';

export function ImportView(props) {
    const { data } = props;
    return (
        <div>
            <div>{data?.id}</div>
            <JsonView src={data} />
        </div>
    );
}

ImportView.propTypes = {};

ImportView.defaultProps = {};

export default ImportView;
